export const truncated = (text: string, characterLimit: number) => {
  const characters = text.split("")
  return characters.slice(0, characterLimit).join("").trim() + "..."
}
